import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Globe, Users, ClipboardCheck, DollarSign, Heart, CheckCircle, ArrowRight, Handshake, BarChart, Building } from 'lucide-react';
export function AfyaProgram() {
  const howItWorksSteps = [{
    title: 'Sign Up',
    description: 'Community members can register online or through Afya outreach teams.',
    icon: <Users className="text-teal-600" size={24} data-id="element-457" data-mp="24u0l6mjq5tkx" />
  }, {
    title: 'Screening',
    description: 'Participants complete a quick screener questionnaire to match them with studies.',
    icon: <ClipboardCheck className="text-teal-600" size={24} data-id="element-458" data-mp="2dqrg2vmjj2dx" />
  }, {
    title: 'Participation',
    description: 'Individuals join a variety of studies: market research (surveys, focus groups, product testing) and clinical research (supplements, probiotics, microbiota reset protocols).',
    icon: <Handshake className="text-teal-600" size={24} data-id="element-459" data-mp="1q0x5yltlvrxd" />
  }, {
    title: 'Compensation',
    description: 'Every participant is paid directly for their time and contributions.',
    icon: <DollarSign className="text-teal-600" size={24} data-id="element-460" data-mp="wb11a8fok4d6" />
  }, {
    title: 'Community Impact',
    description: 'Participation not only provides income but also strengthens science that benefits global health.',
    icon: <Heart className="text-teal-600" size={24} data-id="element-461" data-mp="mdwbzzqjfss5" />
  }];
  const uniqueFeatures = [{
    title: 'Equitable Access',
    description: 'Research opportunities and health solutions reach those who need them most.',
    icon: <CheckCircle className="text-teal-600" size={24} data-id="element-462" data-mp="de99tbpziiy1" />
  }, {
    title: 'Direct Compensation',
    description: 'Participants are rewarded for their contributions.',
    icon: <DollarSign className="text-teal-600" size={24} data-id="element-463" data-mp="27po2o1eakyi0" />
  }, {
    title: 'Global Perspective',
    description: 'Results reflect diverse microbiomes, creating more effective therapies.',
    icon: <Globe className="text-teal-600" size={24} data-id="element-464" data-mp="2ltlkvfbwiwmr" />
  }, {
    title: 'Partnerships',
    description: 'Afya works with NGOs, governments, and clinics to scale impact.',
    icon: <Building className="text-teal-600" size={24} data-id="element-465" data-mp="2cwupz6935ntr" />
  }];
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-466" data-mp="2huwcy29mu7ai">
      <Header data-id="element-467" data-mp="35jyrv2cvtm1b" />
      <main className="flex-grow" data-id="element-468" data-mp="35jfjac94g9zy">
        {/* Hero Section */}
        <section className="relative w-full bg-navy-50" data-id="element-469" data-mp="35huqos6db14q">
          <div className="absolute inset-0 overflow-hidden" data-id="element-470" data-mp="39jzidld99noq">
            <div className="absolute inset-0 bg-cover bg-center opacity-20" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1568092806323-8ea25d878ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80')",
            backgroundBlendMode: 'overlay'
          }} data-id="element-471" data-mp="2vlrknb8eaici" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-600/20 to-navy-600/20" data-id="element-472" data-mp="1hkv9bh3mfu0r" />
          </div>
          <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-473" data-mp="1cm1t3gwy9oww">
            <div className="max-w-3xl" data-id="element-474" data-mp="1qmutgi9xne7x">
              <h1 className="text-3xl md:text-5xl font-bold text-navy-800 mb-4" data-id="element-475" data-mp="1qltdq0hz23jv">
                The Afya Program
              </h1>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-476" data-mp="xxnuji6kgmm5"></div>
              <p className="text-lg md:text-xl text-navy-700 mb-8" data-id="element-477" data-mp="xy6zlyb4bgir">
                Global Health Through Microbiome Science
              </p>
              <a href="#join" className="px-6 py-3 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors duration-200 shadow-sm inline-flex items-center" data-id="element-478" data-mp="17ngwdrgwpnd7">
                Join the Program
                <ArrowRight size={16} className="ml-2" data-id="element-479" data-mp="f5mnvtnjvs26" />
              </a>
            </div>
          </div>
        </section>
        {/* What is Afya Section */}
        <section className="py-16 bg-white" data-id="element-480" data-mp="nvuxpnlytuza">
          <div className="container mx-auto px-4" data-id="element-481" data-mp="nsyyzx2an29s">
            <div className="max-w-3xl mx-auto" data-id="element-482" data-mp="stda5nz6ysc1">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-483" data-mp="ss25zn1u3ike">
                What is Afya?
              </h2>
              <div className="w-20 h-1 bg-teal-600 mb-6" data-id="element-484" data-mp="12jzhkuwr8cjn"></div>
              <p className="text-navy-600 mb-6" data-id="element-485" data-mp="12liymnq8irmh">
                "Afya" means health in Swahili. The Afya Program is the outreach
                and equity branch of our ecosystem, ensuring that advances in
                microbiome research reach underserved communities worldwide.
              </p>
              <p className="text-navy-600" data-id="element-486" data-mp="1gkio1xlknajp">
                Afya not only brings science to where it's needed most, but also
                creates opportunities for individuals to participate in — and be
                compensated for — research studies.
              </p>
              <div className="mt-10 bg-navy-50 p-8 rounded-lg" data-id="element-487" data-mp="3nb8bwwbai5d2">
                <div className="flex items-center mb-4" data-id="element-488" data-mp="24eu6963e4fs9">
                  <div className="bg-teal-100 p-3 rounded-full mr-4" data-id="element-489" data-mp="24gdlctdb8ksg">
                    <Globe className="text-teal-600" size={24} data-id="element-490" data-mp="1znb0raqigloe" />
                  </div>
                  <h3 className="text-xl font-bold text-navy-800" data-id="element-491" data-mp="1vlzad2ztbwf5">
                    Global Impact
                  </h3>
                </div>
                <div className="grid md:grid-cols-3 gap-6 mt-6" data-id="element-492" data-mp="1qpiibxphsxws">
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-493" data-mp="2ncx141imd6xz">
                    <p className="text-3xl font-bold text-teal-600 mb-2" data-id="element-494" data-mp="2jc3cf5xcro41">25+</p>
                    <p className="text-navy-600 text-sm" data-id="element-495" data-mp="2ed067i5mzbuh">
                      Countries with active Afya initiatives
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-496" data-mp="29dx8kirzk7wj">
                    <p className="text-3xl font-bold text-teal-600 mb-2" data-id="element-497" data-mp="12zoaxvny01jx">
                      50,000+
                    </p>
                    <p className="text-navy-600 text-sm" data-id="element-498" data-mp="y1czxhlwvl04">
                      Program participants worldwide
                    </p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-499" data-mp="14dz37ch7o160">
                    <p className="text-3xl font-bold text-teal-600 mb-2" data-id="element-500" data-mp="qgagdz3l2jyb">15+</p>
                    <p className="text-navy-600 text-sm" data-id="element-501" data-mp="vec26rse8xdh">
                      Research partnerships established
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Why Afya Matters Section */}
        <section className="py-16 bg-navy-50" data-id="element-502" data-mp="7ozwi1w9z7fx">
          <div className="container mx-auto px-4" data-id="element-503" data-mp="7qautm6ybmzn">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-504" data-mp="bql4p9xv6xjs">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-505" data-mp="bqut4t39gwnd">
                Why Afya Matters
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-506" data-mp="3tykc0v6pokeg"></div>
              <p className="text-navy-600" data-id="element-507" data-mp="2p539rp125rp">
                Many global populations are left out of mainstream research,
                even though they represent unique microbiomes and pressing
                health needs. Afya changes this by:
              </p>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-508" data-mp="3p8ggdbcqtcab">
              <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-509" data-mp="3k8lslgo9l2th">
                <div className="space-y-6" data-id="element-510" data-mp="3k7am393fpgyo">
                  <div className="flex items-start" data-id="element-511" data-mp="22pgquzca1ax">
                    <div className="bg-teal-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-512" data-mp="2163zecw68dw">
                      <Globe className="text-teal-600" size={20} data-id="element-513" data-mp="3t8qy1l9wdr50" />
                    </div>
                    <div data-id="element-514" data-mp="brh8b20hmjlb">
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-515" data-mp="buv8q4plciq4">
                        Expanding research into Africa, Asia, and underserved
                        regions
                      </h3>
                      <p className="text-navy-600" data-id="element-516" data-mp="kr47dh5qvdb7">
                        We conduct studies in communities that are traditionally
                        overlooked by mainstream medical research, capturing
                        vital data on diverse microbiome profiles.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-517" data-mp="1x625tpftlruh">
                    <div className="bg-teal-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-518" data-mp="216m3cu4b2xh5">
                      <BarChart className="text-teal-600" size={20} data-id="element-519" data-mp="2149qgvdenday" />
                    </div>
                    <div data-id="element-520" data-mp="14e8v2dij5yko">
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-521" data-mp="19f6ip5mb7ktk">
                        Building equity into microbiome science
                      </h3>
                      <p className="text-navy-600" data-id="element-522" data-mp="1dex8b603nuwi">
                        We ensure that the benefits of scientific advancement
                        reach all communities, not just those with economic
                        advantages or proximity to research centers.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-523" data-mp="i86ek2ans0ei">
                    <div className="bg-teal-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-524" data-mp="i5tu9ihfhdya">
                      <DollarSign className="text-teal-600" size={20} data-id="element-525" data-mp="d9mmrl9dvue8" />
                    </div>
                    <div data-id="element-526" data-mp="95ezztmhkoin">
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-527" data-mp="485domue8sz1">
                        Offering participants fair payment for contributing to
                        studies
                      </h3>
                      <p className="text-navy-600" data-id="element-528" data-mp="3qnzqs4xyippr">
                        We recognize the value of participants' time and
                        contributions by providing fair compensation, creating
                        economic opportunities alongside health benefits.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* How It Works Section */}
        <section className="py-16 bg-white" data-id="element-529" data-mp="37r83zlj7hsgy">
          <div className="container mx-auto px-4" data-id="element-530" data-mp="21dnngkhpimnz">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-531" data-mp="21ccjoko9hewv">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-532" data-mp="1xclvmoq4dcw1">
                How It Works
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-533" data-mp="2b6mlsu309rks"></div>
            </div>
            <div className="max-w-4xl mx-auto" data-id="element-534" data-mp="2667as9674w5z">
              <div className="relative" data-id="element-535" data-mp="1ifbasorl6unn">
                {/* Connector Line */}
                <div className="hidden md:block absolute left-[45px] top-[60px] bottom-[60px] w-1 bg-teal-100 z-0" data-id="element-536" data-mp="1ee9bk7xo6ilo"></div>
                <div className="space-y-12" data-id="element-537" data-mp="1sek4dgiji79h">
                  {howItWorksSteps.map((step, index) => <div key={index} className="flex items-start relative z-10" data-id="element-538" data-mp="1neo8k4jzxm50" data-mpi={index}>
                      <div className="bg-teal-100 p-3 rounded-full mr-6 flex-shrink-0" data-id="element-539" data-mp="33sxms5uixui4">
                        <div className="bg-white rounded-full w-8 h-8 flex items-center justify-center" data-id="element-540" data-mp="2yu34r64ds9z2">
                          <span className="font-bold text-teal-600" data-id="element-541" data-mp="kmlgjej83s2q">
                            {index + 1}
                          </span>
                        </div>
                      </div>
                      <div className="bg-navy-50 p-6 rounded-lg shadow-sm flex-grow" data-id="element-542" data-mp="blx0kea9rhn7">
                        <div className="flex items-center mb-3" data-id="element-543" data-mp="gkqgedd13kqj">
                          <div className="bg-white p-2 rounded-full mr-3" data-id="element-544" data-mp="gl9wrpn1612g">
                            {step.icon}
                          </div>
                          <h3 className="text-xl font-bold text-navy-800" data-id="element-545" data-mp="18bo6d9o0gr8b">
                            {step.title}
                          </h3>
                        </div>
                        <p className="text-navy-600" data-id="element-546" data-mp="uiosfc3vn52v">{step.description}</p>
                      </div>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* What Makes Afya Unique Section */}
        <section className="py-16 bg-navy-50" data-id="element-547" data-mp="1s182pkmww6zg">
          <div className="container mx-auto px-4" data-id="element-548" data-mp="21wf8njhgzluw">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-549" data-mp="21v443hg7aa2q">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-550" data-mp="1wxu9zohv9a8k">
                What Makes Afya Unique
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-551" data-mp="1rvv5uceay9ak"></div>
            </div>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-552" data-mp="1my3d5g5u2j5b">
              {uniqueFeatures.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-sm" data-id="element-553" data-mp="1iyunamdwz5f1" data-mpi={index}>
                  <div className="flex items-start" data-id="element-554" data-mp="1e500ha30iabq">
                    <div className="bg-teal-100 p-3 rounded-full mr-4 flex-shrink-0" data-id="element-555" data-mp="196f45lqvsask">
                      {feature.icon}
                    </div>
                    <div data-id="element-556" data-mp="1460u5y5pyqrw">
                      <h3 className="text-xl font-bold text-navy-800 mb-2" data-id="element-557" data-mp="z8slqpadi13u">
                        {feature.title}
                      </h3>
                      <p className="text-navy-600" data-id="element-558" data-mp="v8qgk65fipjt">{feature.description}</p>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        {/* Join the Movement Section */}
        <section id="join" className="py-16 bg-teal-600 text-white" data-id="element-559" data-mp="3fvh082mpko45">
          <div className="container mx-auto px-4" data-id="element-560" data-mp="3fte2sxj87spe">
            <div className="max-w-3xl mx-auto text-center" data-id="element-561" data-mp="3kuto8qpbg18b">
              <h2 className="text-3xl font-bold mb-4" data-id="element-562" data-mp="3ks7gor2fdlq3">Join the Movement</h2>
              <div className="w-20 h-1 bg-white mx-auto mb-6" data-id="element-563" data-mp="2n8mllmckoiyl"></div>
              <p className="text-teal-100 mb-6" data-id="element-564" data-mp="2s6xu9tr4snf8">
                With Afya, you're not just a participant — you're a partner in
                building a healthier world. By joining, you help create data
                that leads to new therapies, while gaining fair compensation for
                your role.
              </p>
              <p className="text-xl font-medium text-white mb-8" data-id="element-565" data-mp="24g1v2bkcipxy">
                Be part of the Afya Program and help advance truth in microbiome
                science.
              </p>
              <div className="flex flex-wrap justify-center gap-4" data-id="element-566" data-mp="ezpsfwxiiyk9">
                <a href="/contact" className="px-6 py-3 bg-white text-teal-600 rounded-md hover:bg-navy-50 transition-colors duration-200 shadow-sm" data-id="element-567" data-mp="aye2fqaq8bbj">
                  Register as a Participant
                </a>
                <a href="/contact" className="px-6 py-3 bg-teal-700 text-white border border-teal-400 rounded-md hover:bg-teal-800 transition-colors duration-200" data-id="element-568" data-mp="yn5nlxpwftet">
                  Partner with Afya
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Featured Success Stories */}
        <section className="py-16 bg-white" data-id="element-569" data-mp="12mo66mu8zseh">
          <div className="container mx-auto px-4" data-id="element-570" data-mp="39ef90143rtuu">
            <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-571" data-mp="39hb7prnrymkc">
              <h2 className="text-3xl font-bold text-navy-800 mb-4" data-id="element-572" data-mp="34hfd2j0yw7hg">
                Success Stories
              </h2>
              <div className="w-20 h-1 bg-teal-600 mx-auto mb-6" data-id="element-573" data-mp="1jyv2qzioy48h"></div>
              <p className="text-navy-600" data-id="element-574" data-mp="1ow4qmaqfm7u7">
                See how the Afya Program is making a difference in communities
                around the world.
              </p>
            </div>
            <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-575" data-mp="1f6l9pama4o1z">
              <div className="bg-navy-50 rounded-lg overflow-hidden shadow-sm" data-id="element-576" data-mp="117v75fgoxw68">
                <img src="https://images.unsplash.com/photo-1571844307880-751c6d86f3f3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1673&q=80" alt="Community health program in Kenya" className="w-full h-48 object-cover" data-id="element-577" data-mp="119y82ujdt9pq" />
                <div className="p-6" data-id="element-578" data-mp="2mlzp4kw3eolt">
                  <h3 className="text-lg font-bold text-navy-800 mb-2" data-id="element-579" data-mp="2mitz93fn3ip1">
                    Kenya: Community Health Initiative
                  </h3>
                  <p className="text-navy-600 text-sm mb-4" data-id="element-580" data-mp="3ecepsnfpces">
                    Partnering with local clinics to study regional microbiome
                    patterns and develop targeted probiotics.
                  </p>
                  <a href="/research" className="text-teal-600 text-sm font-medium hover:text-teal-700 inline-flex items-center" data-id="element-581" data-mp="3qjl9io0410un">
                    Read the case study
                    <ArrowRight size={14} className="ml-1" data-id="element-582" data-mp="m6oimjtqklr1" />
                  </a>
                </div>
              </div>
              <div className="bg-navy-50 rounded-lg overflow-hidden shadow-sm" data-id="element-583" data-mp="dc0beo4lotzl">
                <img src="https://images.unsplash.com/photo-1527613426441-4da17471b66d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1752&q=80" alt="Rural health program in India" className="w-full h-48 object-cover" data-id="element-584" data-mp="d9xah91wtgg3" />
                <div className="p-6" data-id="element-585" data-mp="18dsj5p0lqgr2">
                  <h3 className="text-lg font-bold text-navy-800 mb-2" data-id="element-586" data-mp="18etuzvpfz79u">
                    India: Rural Outreach Program
                  </h3>
                  <p className="text-navy-600 text-sm mb-4" data-id="element-587" data-mp="1ibf34pwrcyhw">
                    Creating economic opportunities through research
                    participation while improving gut health outcomes.
                  </p>
                  <a href="/research" className="text-teal-600 text-sm font-medium hover:text-teal-700 inline-flex items-center" data-id="element-588" data-mp="1ratqvhljiuyp">
                    Read the case study
                    <ArrowRight size={14} className="ml-1" data-id="element-589" data-mp="212g7xukk7o9d" />
                  </a>
                </div>
              </div>
              <div className="bg-navy-50 rounded-lg overflow-hidden shadow-sm" data-id="element-590" data-mp="262kf2tzkv6mx">
                <img src="https://images.unsplash.com/photo-1581056771107-24247a7e6794?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80" alt="Healthcare program in Brazil" className="w-full h-48 object-cover" data-id="element-591" data-mp="2a45wmsn2493g" />
                <div className="p-6" data-id="element-592" data-mp="3aaahl0pm0e78">
                  <h3 className="text-lg font-bold text-navy-800 mb-2" data-id="element-593" data-mp="3a98zica6erg0">
                    Brazil: Urban Health Access
                  </h3>
                  <p className="text-navy-600 text-sm mb-4" data-id="element-594" data-mp="2hlwg2azbazqx">
                    Bringing microbiome testing and personalized protocols to
                    underserved urban communities.
                  </p>
                  <a href="/research" className="text-teal-600 text-sm font-medium hover:text-teal-700 inline-flex items-center" data-id="element-595" data-mp="2rbg0vm6l53of">
                    Read the case study
                    <ArrowRight size={14} className="ml-1" data-id="element-596" data-mp="1yudfsbwo9zsl" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-597" data-mp="9dzyvy96l0it" />
    </div>;
}